import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Alert, Button, Col, Form, Row } from "react-bootstrap";
import { MdSave } from "react-icons/md";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { Loader, ScrollToTop } from "../../../components";

const TambahKategori = () => {
  const { user, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [kode, setKode] = useState("");
  const [nama, setNama] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getKodeKategori = async () => {
      setLoading(true);
      try {
        const response = await axios.post(`${tempUrl}/getKodeKategori`, {
          _id: user.id,
          token: user.token,
        });
        setKode(response.data.kode);
      } catch (err) {
        if (err.response?.status === 401) {
          dispatch({ type: "LOGOUT" });
          navigate("/");
        }
        setError(err.response?.data?.message || "Gagal mengambil kode kategori.");
      }
      setLoading(false);
    };

    getKodeKategori();
  }, [dispatch, navigate, user.id, user.token]);

  const saveKategori = async (event) => {
    event.preventDefault();

    if (!nama.trim()) {
      setError("Nama kategori wajib diisi.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/saveKategori`, {
        nama,
        _id: user.id,
        token: user.token,
      });
      navigate(`/kategori/${response.data.id}`);
    } catch (err) {
      if (err.response?.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setError(err.response?.data?.message || "Gagal menyimpan kategori.");
    }
    setLoading(false);
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div>
      <ScrollToTop />
      <div className="page-header">
        <div>
          <div className="page-kicker">Master</div>
          <h1 className="page-title">Tambah Kategori</h1>
        </div>
      </div>
      <section className="section-panel">
        {error && <Alert variant="warning">{error}</Alert>}
        <Form onSubmit={saveKategori}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Kode</Form.Label>
                <Form.Control value={kode} disabled />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Nama</Form.Label>
                <Form.Control
                  value={nama}
                  onChange={(e) => setNama(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="form-actions mt-3">
            <Button
              className="btn-back"
              type="button"
              variant="outline-secondary"
              onClick={() => navigate("/kategori")}
            >
              {"< Kembali"}
            </Button>
            <Button className="btn-icon" type="submit">
              <MdSave /> Simpan
            </Button>
          </div>
        </Form>
      </section>
    </div>
  );
};

export default TambahKategori;
